export const gossipArticles = [
  {
    slug: "shaqingyan-tongkuang-reyi",
    title: "新剧杀青宴同框画面流出，双方团队暂未回应",
    summary:
      "一场杀青宴上的同框画面被现场人员随手拍下并流出，短短两小时就被顶上讨论区前排，但截至目前双方团队都没有给出正面回应。",
    categorySlug: "entertainment-gossip",
    categoryName: "娱乐八卦",
    cover:
      "https://readdy.ai/api/search-image?query=moody%20banquet%20hall%20with%20warm%20chandeliers%20and%20half%20cleared%20tables%2C%20cinematic%20blur%2C%20stylized%20editorial%20scene%2C%20no%20people%2C%20warm%20amber%20and%20deep%20red%20tones&width=800&height=500&seq=gua-art-01&orientation=landscape",
    author: "瓜料编辑部",
    publishedAt: "2026-09-10 09:20",
    relativeTime: "18 分钟前",
    readCount: 48210,
    hotScore: 98,
    tags: ["杀青宴", "同框", "剧组花絮"],
    featured: true,
    content: [
      "事情的起点其实很普通。某剧组在前一晚完成了最后一组镜头，剧组按惯例办了杀青宴，现场气氛热闹，工作人员随手拍了几段短视频发在朋友圈，本来是内部留念。",
      "问题出在其中一段画面的角度上。视频里两位主演坐在相邻的位置，被剪出来单独传播后，迅速被解读成多种版本。截图在讨论区流转的速度远快于原始视频，等到中午，话题词条的阅读量已经翻了十几倍。",
      "需要说明的是，杀青宴本身就是全组聚在一起的场合，邻座、碰杯、合影都属常见。目前流出的画面没有任何超出常规互动的信息，所谓「实锤」并没有站得住脚的证据，更多是传播链条上层层加码后的想象。",
      "截至发稿，双方团队都没有就此事作出回应。按照以往惯例，这类没有明确信源的同框话题，通常会在新的热点出现后自然降温。我们会继续跟进后续进展，有新的公开信息会第一时间补充。",
    ],
  },
  {
    slug: "zongyi-luzhi-huaxu-bei-fangda",
    title: "综艺录制现场花絮流出，嘉宾互动细节被反复放大",
    summary:
      "一段没有公开播出的录制花絮被剪辑传播，嘉宾之间的一个眼神和半句对话，被解读出了完全不同的含义。",
    categorySlug: "entertainment-gossip",
    categoryName: "娱乐八卦",
    cover:
      "https://readdy.ai/api/search-image?query=television%20studio%20set%20with%20soft%20panel%20lights%20and%20empty%20guest%20chairs%2C%20stylized%20cinematic%20editorial%20mood%2C%20no%20people%2C%20warm%20coral%20and%20cream%20tones&width=800&height=500&seq=gua-art-02&orientation=landscape",
    author: "瓜料编辑部",
    publishedAt: "2026-09-10 08:05",
    relativeTime: "1 小时前",
    readCount: 31540,
    hotScore: 86,
    tags: ["综艺", "花絮", "录制现场"],
    featured: false,
    content: [
      "被传播的是一段节目录制间隙的现场花絮，时长不到二十秒，画面里几位嘉宾在候场区聊天，其中一位在听到某个话题后短暂停顿了一下。",
      "这段花絮并非节目正片内容，也没有完整上下文。剪辑传播的版本掐掉了前后对话，只保留了最容易引发联想的几秒钟，于是同一个表情在不同的人眼里变成了完全不同的信号。",
      "熟悉综艺制作的从业者提醒，录制现场素材量极大，嘉宾之间开玩笑、打岔、走神都很正常，单独拎出一帧去解释人物关系，几乎必然会得出错误结论。",
      "节目组方面目前没有对此单独说明。花絮类内容的生命周期通常很短，等正片播出、完整语境呈现之后，多数猜测都会自行消解。",
    ],
  },
  {
    slug: "jingji-tuandui-tiaozheng-chuanwen",
    title: "经纪团队调整传闻发酵，多个行程临时变更引猜测",
    summary:
      "接连两场公开活动临时调整时间，加上社交账号方向的细微变化，让「团队换血」的说法越传越具体。",
    categorySlug: "entertainment-gossip",
    categoryName: "娱乐八卦",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20office%20meeting%20room%20at%20dusk%20with%20warm%20desk%20lamp%20and%20scattered%20papers%2C%20stylized%20editorial%20scene%2C%20no%20people%2C%20amber%20and%20muted%20red%20tones&width=800&height=500&seq=gua-art-03&orientation=landscape",
    author: "瓜料编辑部",
    publishedAt: "2026-09-09 22:40",
    relativeTime: "昨天 22:40",
    readCount: 27680,
    hotScore: 79,
    tags: ["团队变动", "行程调整"],
    featured: false,
    content: [
      "传闻的源头是两张行程变更公告。原本定在周末的两场品牌活动，先后以「档期协调」为由调整了时间，变更说明措辞简短，没有给出更细的原因。",
      "与此同时，相关社交账号在内容节奏上也出现了变化，连续几天没有更新日常向内容，这种沉默被部分网友当作佐证。",
      "业内常见的团队调整其实分为很多层：可能是宣传口径的临时收紧，可能是个别岗位的人员流动，也可能只是项目排期的正常波动。在没有官方说明前，把这些现象直接等同于「换血」，推断链条偏长。",
      "目前相关方都没有发布人员变动的正式消息。我们会继续观察后续行程安排，如果出现持续的异常，再做进一步梳理。",
    ],
  },
  {
    slug: "xunyan-jiacang-shifenzhong-shouqing",
    title: "巡演官宣加场，开票十分钟售罄再引抢票讨论",
    summary:
      "加场公告发出不到一天，新一轮开票就在十分钟内显示售罄，抢票难的话题再次回到讨论中心。",
    categorySlug: "star-news",
    categoryName: "明星动态",
    cover:
      "https://readdy.ai/api/search-image?query=packed%20concert%20arena%20seen%20from%20empty%20upper%20tier%20with%20sea%20of%20warm%20light%20sticks%2C%20stylized%20cinematic%20blur%2C%20no%20clear%20faces%2C%20crimson%20and%20gold%20atmosphere&width=800&height=500&seq=gua-art-04&orientation=landscape",
    author: "瓜料编辑部",
    publishedAt: "2026-09-10 10:12",
    relativeTime: "刚刚",
    readCount: 52940,
    hotScore: 96,
    tags: ["巡演", "加场", "抢票"],
    featured: true,
    content: [
      "主办方在昨晚宣布为巡演追加一场，消息发出后，预约提醒人数在半小时内突破六位数。今天上午十点开票，十分钟后页面显示全部售罄。",
      "加场通常意味着原定场次的市场反馈超出预期。从现场观众的反馈看，本轮巡演在舞台设计和曲目编排上都做了较大调整，口碑带动了二刷、三刷的需求。",
      "抢票难几乎是每一轮热门巡演的固定话题。除了真实的观演需求，黄牛与代抢工具也在其中推波助澜，这也是为什么很多观众反映「手动刷不过机器」。",
      "主办方暂未公布是否会有进一步加场的计划。按照巡演排期，后续还有几个城市待定，相关消息预计会在开票前一周左右释出。",
    ],
  },
  {
    slug: "xingzhuanji-yure-wuliao-zaoxing-taolun",
    title: "新专辑预热物料释出，造型转变成为讨论焦点",
    summary:
      "一组预热视觉以全新造型亮相，风格转向明显，支持与质疑的声音几乎同时出现，讨论集中在「变还是不变」。",
    categorySlug: "star-news",
    categoryName: "明星动态",
    cover:
      "https://readdy.ai/api/search-image?query=empty%20photo%20studio%20with%20warm%20softbox%20lights%20and%20backdrop%20paper%2C%20stylized%20editorial%20mood%2C%20no%20people%2C%20cream%20and%20amber%20tones%2C%20subtle%20film%20grain&width=800&height=500&seq=gua-art-05&orientation=landscape",
    author: "瓜料编辑部",
    publishedAt: "2026-09-09 20:30",
    relativeTime: "昨天 20:30",
    readCount: 34120,
    hotScore: 82,
    tags: ["新专辑", "视觉概念", "造型"],
    featured: false,
    content: [
      "预热物料一共三张，视觉语言偏向冷调与低饱和，和上一张专辑明亮跳跃的风格拉开了明显距离。文案没有透露曲风，只给了一句概念性的提示。",
      "评论区很快分化成两派。一派认为转型是音乐人必要的自我更新，另一派则担心造型先行、作品跟不上。这种分歧在每次风格切换时几乎都会出现，本身并不说明作品质量。",
      "从行业角度看，视觉先行是当下专辑宣发的常规操作：先用概念图定调，再用单曲落地。真正能决定舆论走向的，还是首支单曲的表现。",
      "按照目前释出的节奏，首支单曲预计会在两周内上线。届时关于「变还是不变」的讨论，会有一份更实在的答案。",
    ],
  },
  {
    slug: "gongyi-huodong-diaosu-xianhen",
    title: "公益活动低调现身，现场照片被网友陆续转发",
    summary:
      "一场没有提前宣传的公益活动上出现了熟悉的身影，现场参与者拍下的照片被慢慢转发开来，讨论意外温和。",
    categorySlug: "star-news",
    categoryName: "明星动态",
    cover:
      "https://readdy.ai/api/search-image?query=sunlit%20community%20garden%20with%20wooden%20benches%20and%20planted%20greenery%2C%20warm%20golden%20hour%20light%2C%20stylized%20editorial%20scene%2C%20no%20people%2C%20fresh%20green%20and%20cream%20tones&width=800&height=500&seq=gua-art-06&orientation=landscape",
    author: "瓜料编辑部",
    publishedAt: "2026-09-09 16:15",
    relativeTime: "昨天 16:15",
    readCount: 21870,
    hotScore: 68,
    tags: ["公益", "现身", "现场"],
    featured: false,
    content: [
      "这场公益活动没有设置媒体环节，也没有在活动前发布任何预告，参与者主要是社区居民和志愿者。活动结束后，才有人把现场照片发到社交平台。",
      "照片里没有刻意摆拍的构图，更多是自然的抓拍。转发的人大多在补充现场细节，比如活动持续了多久、做了哪些具体的事。",
      "和通常的娱乐话题不同，这次讨论的基调明显更平和。不少评论在提醒不必过度关注个人，把注意力放回活动本身想解决的问题上。",
      "相关机构工作人员表示，活动按计划完成，后续还会有几场同类安排，但同样不会做提前宣传。我们尊重这种低调的处理方式，也不对参与者身份做额外推测。",
    ],
  },
  {
    slug: "xuanyi-juji-koubei-fenhua",
    title: "悬疑剧集更新过半，口碑分化背后是叙事节奏之争",
    summary:
      "同一部剧，有人夸氛围拉满，有人嫌推进太慢。更新过半后，讨论的重点从剧情转向了叙事节奏本身。",
    categorySlug: "film-tv",
    categoryName: "影视综艺",
    cover:
      "https://readdy.ai/api/search-image?query=rain%20slicked%20narrow%20alley%20at%20night%20with%20warm%20streetlamp%20glow%20and%20fog%2C%20stylized%20cinematic%20noir%20mood%2C%20no%20people%2C%20charcoal%20and%20amber%20tones&width=800&height=500&seq=gua-art-07&orientation=landscape",
    author: "瓜料编辑部",
    publishedAt: "2026-09-10 07:45",
    relativeTime: "1 小时前",
    readCount: 38950,
    hotScore: 88,
    tags: ["悬疑剧", "口碑", "叙事"],
    featured: true,
    content: [
      "剧集上线两周，更新到第十二集。从评分分布看，高分段和低分段都相当集中，中间地带反而很少，这种结构通常意味着作品的风格足够鲜明。",
      "喜欢的一方普遍提到镜头语言和氛围营造，认为慢是为了铺垫；不喜欢的一方则觉得信息密度不足，几集下来推进有限。两边的评价其实指向同一个特征：这是一部把节奏当作叙事手段的作品。",
      "节奏快慢本身不是质量高低的标准，问题在于节奏是否服务于人物和悬念。从前十二集看，编剧更愿意用环境与细节交代动机，这决定了它天然不适合倍速观看。",
      "后期预告显示，接下来的四集将集中回收前期的伏笔。真正的口碑分水岭大概率出现在这里，届时评价结构可能会有一次明显变化。",
    ],
  },
  {
    slug: "manzongyi-gaiban-shoubo-kanidian",
    title: "慢综艺改版首播，嘉宾化学反应成为最大看点",
    summary:
      "改版后的慢综艺首播，节奏更缓、任务更少，观众评价几乎一致地落在了同一件事上：人和人之间的关系好不好看。",
    categorySlug: "film-tv",
    categoryName: "影视综艺",
    cover:
      "https://readdy.ai/api/search-image?query=wooden%20farmhouse%20kitchen%20with%20steaming%20kettle%20and%20warm%20morning%20light%20through%20window%2C%20stylized%20editorial%20scene%2C%20no%20people%2C%20earthy%20amber%20and%20cream%20tones&width=800&height=500&seq=gua-art-08&orientation=landscape",
    author: "瓜料编辑部",
    publishedAt: "2026-09-09 19:00",
    relativeTime: "昨天 19:00",
    readCount: 24130,
    hotScore: 72,
    tags: ["慢综艺", "改版", "首播"],
    featured: false,
    content: [
      "改版最直观的变化是任务被大幅削减。上一季标志性的挑战环节被拿掉，取而代之的是更多自然发生的日常，剪辑也更愿意留住安静的时刻。",
      "首播之后，观众提到最多的不是场景，而是嘉宾之间的相处方式：谁在主动照顾节奏，谁负责活跃气氛，谁总在默默收拾残局。这些细节构成了节目的真实感。",
      "慢综艺的成败几乎完全押在「人」上。场景可以搭，流程可以设计，但关系是否自然无法伪造。首播里几段没有台词的长镜头，反而是评论区讨论最多的地方。",
      "节目组表示后续不会刻意增加冲突，会继续保持低干预的拍摄方式。这一路线能否走通，要看嘉宾关系在中后段是否仍然耐看。",
    ],
  },
  {
    slug: "shuqi-dang-dingdang-paipian-taolun",
    title: "暑期档片单陆续定档，题材扎堆引发排片讨论",
    summary:
      "几部备受期待的作品在同一周内密集定档，题材分布高度接近，排片与观众分流重新成为行业话题。",
    categorySlug: "film-tv",
    categoryName: "影视综艺",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20cinema%20marquee%20lights%20at%20night%20with%20warm%20bulbs%20and%20dark%20facade%2C%20no%20text%2C%20no%20people%2C%20cinematic%20editorial%20mood%2C%20crimson%20and%20gold%20tones&width=800&height=500&seq=gua-art-09&orientation=landscape",
    author: "瓜料编辑部",
    publishedAt: "2026-09-08 21:10",
    relativeTime: "9 月 8 日",
    readCount: 19640,
    hotScore: 64,
    tags: ["暑期档", "定档", "排片"],
    featured: false,
    content: [
      "短短一周内，多部作品先后官宣档期，其中三部题材相近，都带有明显的悬疑与情感混合标签。档期公布后，关于「会不会互相消耗」的讨论立刻出现。",
      "档期扎堆在行业里并不新鲜，往往与制作周期和奖项节点相关。真正的变量是首周末的口碑扩散速度，口碑一旦跑起来，后定档的作品也能分到自己的观众。",
      "从往年的数据看，同题材并不必然导致分流，反而是差异化表达的作品更容易被记住。观众的选择往往围绕「这一部和那一部有什么不一样」展开。",
      "目前各片方都还没有公布更细的宣发计划。随着临近上映，路演、点映等安排会陆续放出，届时真实的市场判断才有依据。",
    ],
  },
  {
    slug: "huati-citiao-yiye-chongbang",
    title: "话题词条一夜冲上榜单，讨论量持续走高",
    summary:
      "一个并不起眼的词条在凌晨突然加速，几个小时就挤进榜单前列，讨论量还在往上走。",
    categorySlug: "hot-topics",
    categoryName: "网络热点",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20glowing%20data%20lines%20and%20warm%20orange%20particles%20on%20dark%20background%2C%20stylized%20tech%20editorial%20visual%2C%20no%20text%2C%20no%20people%2C%20coral%20and%20amber%20tones&width=800&height=500&seq=gua-art-10&orientation=landscape",
    author: "瓜料编辑部",
    publishedAt: "2026-09-10 06:30",
    relativeTime: "2 小时前",
    readCount: 61420,
    hotScore: 99,
    tags: ["热搜", "话题", "传播"],
    featured: true,
    content: [
      "词条的上升曲线很有特点：凌晨两点之前几乎是一条平线，之后突然陡峭上扬，到早上六点已经进入榜单前列。这种形状通常意味着有明确的启动节点。",
      "追踪传播路径可以看到，最早的一批讨论集中在小范围的社群，随后被几个高互动的账号转发，触发了第一轮扩散。内容和情绪都在这个过程中被简化，方便了传播。",
      "值得注意的是，热度并不等于争议。这次讨论里，多数参与者在补充细节和提出疑问，情绪化的对立并不多，这也是它能持续往上走的原因之一。",
      "热度的可持续性取决于是否还有新信息补充。如果后续只是重复已有内容，讨论量会在一到两天内回落；如果持续有新的进展释出，话题周期会被明显拉长。",
    ],
  },
  {
    slug: "duanshipin-tiaozhansai-erci-chuanbo",
    title: "短视频挑战赛带动二次传播，创作者集体跟拍",
    summary:
      "一个简单的动作模板在几天内被大量复制，从素人到品牌账号都在跟拍，二次传播把话题推到了更远的地方。",
    categorySlug: "hot-topics",
    categoryName: "网络热点",
    cover:
      "https://readdy.ai/api/search-image?query=ring%20light%20and%20smartphone%20on%20tripod%20in%20warm%20home%20studio%2C%20stylized%20editorial%20creator%20scene%2C%20no%20people%2C%20coral%20and%20cream%20tones%2C%20soft%20blur&width=800&height=500&seq=gua-art-11&orientation=landscape",
    author: "瓜料编辑部",
    publishedAt: "2026-09-09 14:20",
    relativeTime: "昨天 14:20",
    readCount: 28390,
    hotScore: 75,
    tags: ["短视频", "挑战赛", "二次传播"],
    featured: false,
    content: [
      "挑战的门槛低是关键。动作模板只有三步，配乐固定，任何人都能在几分钟内完成拍摄，这让参与成本几乎降到了最低。",
      "真正的转折出现在品牌账号加入之后。几个官方账号用同样的模板做了改编，把产品和动作结合起来，话题因此跳出了原本的兴趣圈层。",
      "二次传播的规律是：低门槛 + 可改编 + 强识别。三项凑齐，内容就会像滚雪球一样扩散；缺一项，热度往往只能维持一两天。",
      "平台方目前还没有公布挑战赛的官方数据。从参与数量看，这轮传播仍处在上升期，是否会形成长尾，要看有没有新的改编版本延续。",
    ],
  },
  {
    slug: "kuajie-lianming-shangjia-jiqiangkong",
    title: "跨界合作官宣，联名产品上架即被抢空",
    summary:
      "两个看起来不太相关的领域宣布联名，产品上架几分钟就显示售罄，二手渠道的价格迅速被抬了起来。",
    categorySlug: "hot-topics",
    categoryName: "网络热点",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20product%20still%20life%20on%20cream%20backdrop%20with%20warm%20side%20lighting%20and%20clean%20shadows%2C%20stylized%20editorial%20commerce%20photography%2C%20no%20text%2C%20coral%20and%20amber%20tones&width=800&height=500&seq=gua-art-12&orientation=landscape",
    author: "瓜料编辑部",
    publishedAt: "2026-09-08 11:00",
    relativeTime: "9 月 8 日",
    readCount: 33210,
    hotScore: 80,
    tags: ["联名", "跨界", "售罄"],
    featured: false,
    content: [
      "官宣方式很克制，只有一张概念图和一句「限量发售」，没有透露具体数量。这种信息留白反而放大了期待，预约人数在两天内累计到相当高的量级。",
      "上架当天的情况几乎是秒空的。有参与抢购的网友反映，页面在开售瞬间就进入了排队状态，等到刷新时已经显示无货。",
      "联名的价值往往在于两边的用户互相被吸引。这次合作里，双方的核心人群重叠度并不高，这也是它能触达新用户的原因，同时也解释了为什么需求会集中爆发。",
      "目前官方没有公布是否补货。从二手渠道的价格波动看，短期内的溢价空间依然存在，但联名产品的中长期价值通常取决于设计本身能否独立成立。",
    ],
  },
  {
    slug: "yinyuejie-yaogun-wutai-xianchang",
    title: "音乐节主舞台反响两极，现场表现成为讨论重点",
    summary:
      "同一支乐队，线上直播的观众和现场观众给出了几乎相反的评价，差异的来源指向了演出本身的特点。",
    categorySlug: "music-live",
    categoryName: "音乐现场",
    cover:
      "https://readdy.ai/api/search-image?query=outdoor%20music%20festival%20stage%20at%20dusk%20with%20warm%20amber%20lights%20and%20crowd%20silhouettes%2C%20stylized%20cinematic%20editorial%20mood%2C%20no%20clear%20faces%2C%20crimson%20and%20gold%20tones&width=800&height=500&seq=gua-art-13&orientation=landscape",
    author: "瓜料编辑部",
    publishedAt: "2026-09-10 08:50",
    relativeTime: "1 小时前",
    readCount: 20430,
    hotScore: 70,
    tags: ["音乐节", "现场", "舞台"],
    featured: false,
    content: [
      "这场演出在傍晚开场，是当天的压轴环节之一。现场观众的评价相当热烈，反复提到的是声音层次和整体氛围。",
      "线上直播的反馈却明显分化，一部分观众觉得混音偏闷，人声被乐器压住，观感打了折扣。两边的分歧其实集中在同一个技术环节上。",
      "户外音乐节的现场与直播本就是两套听觉体验。现场依赖场地反射与低音冲击，直播则高度依赖调音台的混音版本，任何一方的处置偏差都会被放大。",
      "演出方暂未对直播音质作出说明。从往年经验看，音乐节直播的混音优化通常需要一两轮磨合，后续场次的表现值得再观察。",
    ],
  },
  {
    slug: "livehouse-xiaochang-kaipiao-fankui",
    title: "Livehouse 小场巡演开票，近距离演出为何更受追捧",
    summary:
      "没有大屏幕也没有升降台，一场百人规模的小场演出却在一小时内售罄，观众的偏好正在发生变化。",
    categorySlug: "music-live",
    categoryName: "音乐现场",
    cover:
      "https://readdy.ai/api/search-image?query=intimate%20small%20venue%20stage%20with%20warm%20string%20lights%20and%20wooden%20floor%2C%20stylized%20editorial%20scene%2C%20no%20people%2C%20amber%20and%20deep%20red%20tones%2C%20soft%20blur&width=800&height=500&seq=gua-art-14&orientation=landscape",
    author: "瓜料编辑部",
    publishedAt: "2026-09-08 18:40",
    relativeTime: "9 月 8 日",
    readCount: 15720,
    hotScore: 58,
    tags: ["Livehouse", "小场", "巡演"],
    featured: false,
    content: [
      "这场演出的场地容量不到三百人，票价不高，开票后一小时内售罄。和大型巡演不同，它没有复杂的舞台机械，主打的是距离感。",
      "观众对小场演出的偏好，很大程度上来自「看得清、听得真」。在百人场地里，乐手的每一个表情、每一次即兴都能被直接感知，这是大型场馆很难提供的体验。",
      "对音乐人来说，小场巡演也是更可控的表达空间。曲目可以随时调整，与观众的互动更自然，试错成本也更低。",
      "主办方表示后续会继续安排类似规模的城市巡演。小场演出虽难有可观的票房体量，但它正在成为音乐人维系核心听众的重要方式。",
    ],
  },
];